import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.unref(_ctx.visibility) !== _ctx.Visibility.None)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectTab && _ctx.selectTab(...args))),
        class: _normalizeClass(["tabButton", {
            active: _ctx.active,
            ..._ctx.unref(_ctx.classes)
        }]),
        style: _normalizeStyle([
            {
                visibility: _ctx.unref(_ctx.visibility) === _ctx.Visibility.Hidden ? 'hidden' : undefined
            },
            _ctx.glowColorStyle,
            _ctx.unref(_ctx.style) ?? {}
        ])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component)))
      ], 6))
    : _createCommentVNode("", true)
}